var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_1_1",
    "data-name": "Component 1 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 202.721,
    height: 202.721,
    viewBox: "0 0 202.721 202.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 196,
    height: 196,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 0.69, 7.483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(-0.667 -0.666)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M194.642,97.322A97.321,97.321,0,1,1,97.32,0a97.323,97.323,0,0,1,97.322,97.322",
    transform: "translate(0.679 0.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M99.552,33.083c-9.119-6.283-22.673-3.037-32.692,7.334-9.753-10.1-22.852-13.431-31.955-7.807-.087.05-.172.108-.259.16s-.2.119-.3.181c-.2.128-.4.256-.6.391-.08.055-.16.112-.238.169-.247.174-.492.355-.73.542-.217.169-.433.346-.643.524-.055.048-.108.1-.163.146A19.153,19.153,0,0,0,28.9,38.178c-.108.156-.213.314-.318.469l-.076.117c-5.28,7.952-6.393,20.4-2.033,32.566,3.436,9.586,9.545,16.967,16.375,20.824a18.327,18.327,0,0,0,2.085,1.229,18.12,18.12,0,0,0,21.92-4.624,18.116,18.116,0,0,0,21.918,4.624,18.609,18.609,0,0,0,2.152-1.275c6.8-3.868,12.873-11.229,16.3-20.778,5.628-15.7,2.145-31.886-7.665-38.247",
    transform: "translate(31.324 39.195)",
    fill: "#e33c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M64.5,28.967V29a33.921,33.921,0,0,0-40.705.009,33.926,33.926,0,0,0,40.705.011V52.9H69.13V28.967Z",
    transform: "translate(31.352 29.322)",
    fill: "#164122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M22.976,52.07A7.5,7.5,0,1,0,8.258,54.963,7.5,7.5,0,1,0,22.976,52.07m-6.649,5.106a3.717,3.717,0,1,1-1.447-7.283,3.72,3.72,0,1,1,1.447,7.283",
    transform: "translate(11.121 59.759)",
    fill: "#164122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M29.937,64.65a7.5,7.5,0,1,0-10.4,10.813,7.5,7.5,0,1,0,10.4-10.813M22.05,72.883a3.674,3.674,0,0,1,.007-5.374,3.72,3.72,0,1,1,5.367,5.134,3.711,3.711,0,0,1-5.374.24",
    transform: "translate(22.74 81.144)",
    fill: "#164122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M28.885,78a3.937,3.937,0,0,1,4-6.775A4.031,4.031,0,0,1,34.8,74.776l3.424-.439a6.851,6.851,0,0,0-3.575-6.221A7.521,7.521,0,1,0,27,81.066a6.914,6.914,0,0,0,7.189.1l-1.284-3.184A4.145,4.145,0,0,1,28.885,78",
    transform: "translate(30.521 87.02)",
    fill: "#164122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M35.936,81.313a3.791,3.791,0,0,1-2.946-3.96L42.558,80.5a9.827,9.827,0,0,0,.916-1.962,6.516,6.516,0,0,0-4.342-8.45,7.408,7.408,0,0,0-9.483,4.8,7.517,7.517,0,0,0,5.129,9.6,8.746,8.746,0,0,0,6.127-.252l-.712-3.042a6.311,6.311,0,0,1-4.257.128m2.076-8.267a2.919,2.919,0,0,1,2.039,3.726l-6.2-2.037a3.51,3.51,0,0,1,4.161-1.689",
    transform: "translate(38.389 90.498)",
    fill: "#164122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M50.29,68.139l.174,8.787A5.653,5.653,0,0,0,46.14,75.3c-4.063.082-6.9,3.333-6.812,7.656s3.049,7.453,7.111,7.372a5.515,5.515,0,0,0,4.569-2.211l.034,1.767,3.6-.069-.435-21.763Zm.35,14.591a3.572,3.572,0,0,1-3.545,4.017,3.969,3.969,0,0,1-.16-7.919,3.616,3.616,0,0,1,3.706,3.9",
    transform: "translate(51.365 88.394)",
    fill: "#164122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M62.312,76.205a7.709,7.709,0,1,0-5.473,9.311,7.559,7.559,0,0,0,5.473-9.311m-6.4,5.834a3.926,3.926,0,0,1-2.085-7.558A3.926,3.926,0,0,1,55.91,82.04",
    transform: "translate(61.482 91.859)",
    fill: "#164122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M74.827,70.221c-2.483-3.536-6.7-4.482-10.023-2.142a5.651,5.651,0,0,0-2.531,3.868l-5.054-7.2-3.207,2.255L66.527,84.82l2.946-2.074L68.455,81.3a5.591,5.591,0,0,0,4.994-.92c3.326-2.339,3.866-6.622,1.378-10.158M70.8,77.875a3.978,3.978,0,0,1-4.557-6.484A3.971,3.971,0,0,1,70.8,77.875",
    transform: "translate(70.293 84.133)",
    fill: "#164122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M77.972,61.116,71.319,56.6l-2.2,3.246,6.919,4.694a2.7,2.7,0,1,1-3.028,4.468l-6.919-4.694-2.2,3.243,6.656,4.516a6.621,6.621,0,1,0,7.434-10.957",
    transform: "translate(83.014 73.627)",
    fill: "#164122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M73.877,54.236l.412-.961-3.179-1.357a4.065,4.065,0,0,0-.657,1.106,4.936,4.936,0,0,0,.179,4.369l-1.57-.671-1.417,3.305,13.209,5.647,1.538-3.6L75.8,59.255c-2.376-1.019-2.818-2.941-1.927-5.019",
    transform: "translate(87.862 67.592)",
    fill: "#164122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M73.011,49.261a5.542,5.542,0,0,0-2.992,4.1c-.808,3.983,1.746,7.464,5.985,8.32s7.947-1.355,8.753-5.335a5.562,5.562,0,0,0-1.089-4.873l1.655.334.723-3.584L71.961,45.375,71.249,48.9Zm5.242,1.328a3.578,3.578,0,0,1,3.152,4.34,3.972,3.972,0,0,1-7.771-1.57,3.618,3.618,0,0,1,4.619-2.77",
    transform: "translate(90.733 59.16)",
    fill: "#164122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M30.677,70.643,20.7,71.694l6.269-7.835-2.106-3.852-1.9,2.58-6.851.723,6.269-7.835-2.108-3.854L10.588,64.537l1.451,2.657,7.626-.114-4.408,6,1.458,2.664L32.8,74.523Z",
    transform: "translate(14.325 67.21)",
    fill: "#164122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M64.036,60.645a2.461,2.461,0,0,0-3.516.142,2.431,2.431,0,1,0,3.516-.142",
    transform: "translate(77.753 77.975)",
    fill: "#164122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M62.811,64.86l-1.527,1.6,2.84,2.715,1.527-1.6,7.569,7.233,2.715-2.838-10.41-9.947Z",
    transform: "translate(79.666 80.615)",
    fill: "#164122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M162.68,84.35h-4.241a72.858,72.858,0,1,0-145.716,0H8.479a77.1,77.1,0,1,1,154.2,0",
    transform: "translate(11.607 10.022)",
    fill: "#164122"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.17999096db9d809b1eb0297b8edc2292.svg";
export { ForwardRef as ReactComponent };